<template>
  <div v-if="isActive" class="temporary-system-notice">
    <div class="notice-header">
      <b-icon icon="exclamation-triangle" class="notice-icon" />
      <strong>Tehniskie darbi sistēmā</strong>
      <span class="notice-date">{{ dateRange }}</span>
    </div>

    <div class="notice-text">
      Cienījamie klienti, informējam, ka saistībā ar pāreju uz jaunu grāmatvedības sistēmu no 1. līdz 5. jūnijam šādas portāla funkcijas nebūs pieejamas:
    </div>

    <ul class="notice-list">
      <li>Atskaišu iesniegšana</li>
      <li>Rēķinu sagatavošana un saņemšana</li>
      <li>Konta bilances attēlošana portālā</li>
    </ul>

    <div class="notice-success">
      Pēc sistēmas pārejas pabeigšanas visas funkcionalitātes tiks pilnībā atjaunotas. Konta bilance tiks aktualizēta automātiski.
    </div>

    <div class="notice-muted">
      Atvainojamies par sagādātajām neērtībām un pateicamies par sapratni!
    </div>
  </div>
</template>

<script>
import { temporarySystemNoticeDateRange, temporarySystemNoticeIsActive } from '@/config/temporarySystemNotice'

export default {
  name: 'TemporarySystemNotice',
  computed: {
    dateRange () {
      return temporarySystemNoticeDateRange()
    },
    isActive () {
      return temporarySystemNoticeIsActive()
    }
  }
}
</script>

<style lang="scss" scoped>
.temporary-system-notice {
  margin-bottom: 18px;
  padding: 14px 18px 12px;
  border: 1px solid #f5b84b;
  border-left: 5px solid #f0a000;
  background: #fff3dd;
  color: #56370b;
  font-size: 16px;
  line-height: 1.35;
}

.notice-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 6px;
  font-size: 18px;
}

.notice-icon {
  color: #a66b00;
}

.notice-date {
  display: inline-block;
  min-width: 220px;
  padding: 4px 22px;
  border-radius: 18px;
  background: #ffc96b;
  color: #5c3b08;
  font-weight: 500;
  text-align: center;
}

.notice-text {
  margin-bottom: 4px;
}

.notice-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 36px;
  margin: 4px 0 6px 16px;
  padding-left: 14px;
}

.notice-list li {
  padding-right: 8px;
}

.notice-success {
  margin-top: 4px;
  color: #4f8426;
}

.notice-muted {
  margin-top: 4px;
  color: #7b7f86;
}

@media (max-width: 768px) {
  .temporary-system-notice {
    padding: 12px 14px;
    font-size: 14px;
  }

  .notice-header {
    align-items: flex-start;
    font-size: 16px;
  }

  .notice-date {
    min-width: 0;
    width: 100%;
  }

  .notice-list {
    display: block;
  }
}
</style>
